module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("848tb"))).then(() => parcelRequire('hEqeo'));